var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "top-card-display__single-card top-card-display__single-card--usage"
    },
    [
      _vm.currentAccount
        ? _c("div", [
            _vm.loadState === "complete"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "top-banner-card gds-card gds-data-card top-banner-card--logged-in"
                  },
                  [
                    _c("div", [
                      _c(
                        "p",
                        { staticClass: "gds-display-0 gds-space-stack-s" },
                        [_vm._v("Usage This Billing Period")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "gds-card__caption" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.daysLeft) + "\n          "
                        ),
                        _vm.daysLeft !== 1
                          ? _c("span", [_vm._v("days")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.daysLeft === 1
                          ? _c("span", [_vm._v("day")])
                          : _vm._e(),
                        _vm._v("\n          left\n        ")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.currentUsage !== undefined
                      ? _c(
                          "figure",
                          { staticClass: "gds-align--block-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card__usage--kw-wrap gds-flex-container gds-clickable",
                                on: {
                                  click: function($event) {
                                    return _vm.navUsage()
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "card__usage--kw-number" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberComma")(_vm.currentUsage)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "card__usage--kwh" }, [
                                  _vm._v("kWh")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "gds-align--block-center",
                              attrs: {
                                src:
                                  "/wp-content/themes/gmptwentynineteen/assets/images/electric-plug.svg",
                                alt: "electric plug"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.lastUsage !== undefined
                      ? _c("div", { staticClass: "card__usage--details" }, [
                          _vm._v(
                            "\n        Last billing period you used a total of\n        "
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "gds-font-demi gds-clickable",
                              on: {
                                click: function($event) {
                                  return _vm.navUsage()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("numberComma")(_vm.lastUsage)) +
                                  " kWh"
                              )
                            ]
                          ),
                          _vm._v(".\n      ")
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loadState !== "complete"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "top-banner-card gds-card gds-data-card top-banner-card--logged-in",
                    class: { "gds-loading": _vm.loadState === undefined }
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.loadState === "error"
                      ? _c("div", { staticClass: "card-error" }, [
                          _vm._v("\n        Unable to load,\n        "),
                          _c("br"),
                          _vm._v("please try again later.\n      ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loadState === "error"
                      ? _c("div", { staticClass: "card-error-layout-blank" }, [
                          _vm._v(" ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loadState === "unavailable"
                      ? _c("div", { staticClass: "card-error" }, [
                          _vm._v(
                            "Usage information is not available for this account."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loadState === "unavailable"
                      ? _c("div", { staticClass: "card-error-layout-blank" }, [
                          _vm._v(" ")
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "gds-display-0 gds-space-stack-s" }, [
        _vm._v("Usage This Billing Period")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }